import { Search } from 'lucide-react'
import { PageHeader } from '@/components/shared/PageHeader'
import { EmptyState } from '@/components/shared/EmptyState'

export function AuditoriaPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Auditoría de Permisos"
        description="Historial de cambios y auditoría de permisos en la plataforma."
      />
      <EmptyState
        icon={<Search size={24} />}
        title="Próximamente"
        description="Esta sección es exclusiva para empleados Kashio."
      />
    </div>
  )
}
